import React from 'react';

const GlobalLoader = ({ message = 'Carregando...' }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white flex flex-col items-center justify-center relative overflow-hidden">
      {/* Decorative blurred background circles */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-gray-200/40 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-48 bg-gray-300/30 rounded-full blur-2xl pointer-events-none mt-10 ml-10"></div>
      
      <div className="text-center relative z-10 flex flex-col items-center">
        {/* Modern Spinner */}
        <div className="relative w-14 h-14 mb-6">
          <div className="absolute inset-0 rounded-full border-[3px] border-gray-200"></div>
          <div className="absolute inset-0 rounded-full border-[3px] border-transparent border-t-[#0a0a0a] border-r-gray-700 animate-spin"></div>
        </div>
        
        <h3 className="text-lg font-bold text-gray-900 tracking-tight mb-1">
          {message}
        </h3>
        <p className="text-sm text-gray-500 font-light">
          Aguarde um momento
        </p>
      </div>
    </div>
  );
};

export default GlobalLoader;
